import { AnalyticsBrowser } from "@segment/analytics-next"

import { getProfileFullName } from "./utils"

class SegmentTracker {
  constructor() {
    this.analytics = new AnalyticsBrowser()
    this.analytics.load({ writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY })
    this.isImpersonator = false
  }

  identify(profile) {
    this.analytics.identify(profile.email, {
      $email: profile.email,
      $name: getProfileFullName(profile),
      $first_name: profile.first_name,
      $last_name: profile.last_name,
      $phone: profile.phone,
      $avatar: profile.profile_image,
    })
  }

  updateProfile(profile) {
    this.identify(profile)
  }

  updateProfileFromCRMSettings(profile, crmSettings) {
    this.#updateProfileFromProperties(profile, {
      "Job Title": crmSettings.broker_title,
      Brokerage: crmSettings.brokerage_name,
    })
  }

  updateProfileFromGmailAuth(profile, emailAuth) {
    this.#updateProfileFromProperties({
      "Gmail Authenticated": emailAuth.authorized,
    })
  }

  #updateProfileFromProperties(profile, properties) {
    this.analytics.identify(profile.email, properties)
  }

  track(eventName, eventData) {
    this.analytics.track(eventName, {
      ...eventData,
      impersonator: this.isImpersonator,
    })
  }

  markImpersonator() {
    this.isImpersonator = true
  }

  deImpersonate() {
    this.isImpersonator = false
  }

  logout() {
    this.analytics.reset()
  }
}

export default new SegmentTracker()
